import { AnimatedPageHeader } from '@components/index'
import { EmailHistoryPanel } from '@features/sendEmail/components/EmailHistoryPanel'
import { SendEmailForm } from '@features/sendEmail/components/SendEmailForm'
import { useTranslation } from 'react-i18next'

export function SendEmail() {
  const { t } = useTranslation('admin')

  return (
    <div className="space-y-6">
      <AnimatedPageHeader title={t('sendEmail.pageTitle')} />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-[minmax(0,1fr)_22rem]">
        <SendEmailForm />
        <EmailHistoryPanel />
      </div>
    </div>
  )
}
